import React from "react";
import "./session-countdown.css";
import useSessionTimer from "../hooks/useSessionTimer";
import { useTranslation } from "react-i18next";

const SessionCountdown: React.FC = () => {
  const { getRemainingTime } = useSessionTimer();
  const timeLeft = getRemainingTime();
  const { t } = useTranslation();

  const minutes = Math.floor(timeLeft / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);

  if (timeLeft <= 0) return null;

  return (
      <div className={`session-countdown ${timeLeft <= 60000 ? "warning" : ""}`}>
        {t("sessionCountdown.full", {
          time: `${minutes}:${seconds.toString().padStart(2, "0")}`,
        })}
      </div>
  );
};

export default SessionCountdown;
